import React, { Component } from 'react';
import $ from 'jquery';

import Vas from '../../../Vas';
import '../../../css/CustomerVerificationData.css';

import { PagingTable } from 'component-lib';
import { ConfirmationsModel, RequestAjaxClass} from 'models-lib';

class CustomerVerificationData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Payments = [];
        this.state.CurrentView = "CustomerData";
        this.CustomerId = localStorage.getItem('employee_id') ? localStorage.getItem('employee_id'):localStorage.getItem("vas_customerId");
        this.state.Ref=this.props.me;
        this.state.Limit = 10;
        this.state.Start = 0;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.ConfirmationsModel = new ConfirmationsModel([this],null,this.Request);
        this.IconConfig = Vas.Config.ShowIconsOrButtons;
    }

    componentDidMount(){
      this.LogoClick();

      this.FontSizeClick();
    }

    componentWillMount(){
      $("#LoadingIcon").removeClass().addClass('loaderSmall');
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      this.Request.setErrorHandler(()=>{
          $("#LoadingIcon").removeClass().addClass('hide');
      });
    }

    load(sendData){
      this.ConfirmationsModel.GetConfirmationsByCustomerId(this.CustomerId,sendData);
    }

    Update(observer)
    {
        this.setState({},()=>{
            let me = this;
            if(observer === "Confirmations"){
                if (me.refs.table){
                    me.refs.table.setState({ Data: me.ConfirmationsModel.Confirmations, Count: me.ConfirmationsModel.Count, Limit: me.ConfirmationsModel.Limit, Start: me.ConfirmationsModel.Start, End: me.ConfirmationsModel.Start+me.ConfirmationsModel.Confirmations.length });
                }
                $("#LoadingIcon").removeClass().addClass('hide');
            }
        });

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){

        $('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #1d5c87;');
        $('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        $('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        $(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function() {
          $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function() {
          $(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #1d5c87;');
        });

        $(".selected").mouseenter(function() {
          $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function() {
          $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        });

        $(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").attr('style', 'background-color: rgba(29, 92, 135, 0.1); border-bottom: 1px solid #1d5c87;');
      }
    }

    Upload(){
        Vas.GetView("CustomerVerificationUpload",{CustomerId:this.CustomerId},true);
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #1d5c87;');
        $('.pagingTable th, .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
        $('#MenuItem_Bearbeiten').attr('style', 'background-color: #1d5c87;');
        $('#MenuItem_Hinzufügen').attr('style', 'background-color: #1d5c87;');
      }
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');
  
      //Schriftgröße bei Klick in 2er Schritten erhöhen
      //$('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");
  
        if(schriftgröße != null){
              switch(schriftgröße){
                case "0":
                  $('#customerCardHeadline').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");
                  $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                break;
                case "1":
                  $('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");
                  $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");                     
                break;
                case "2":
                  $('#customerCardHeadline').removeClass("Schriftgröße_17").addClass("Schriftgröße_18"); 
                  $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");       
  
                break;
                case "3":
                  $('#customerCardHeadline').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                  $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                break;
                case "4":
                  $('#customerCardHeadline').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                  $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                break;
                case "5":
                  $('#customerCardHeadline').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                  $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                break;
              }
        }
    };

    render()
    {  
        let upload='';
        if (this.state.Upload === true){
            upload=(<div 
              className={"paymentDetails"} 
              id={"uploadDocument"} >
            </div>);
        } else {
            upload=<div></div>;
        }

        return (
          <div id={"customerVerifications"}>
            <div id={"customerCardHeadline"} style={{ paddingTop: '10px', paddingLeft: '10px', fontSize: 'calc(15px + 0.2vw)' }}><b>{Vas.Resources.Labels["Verifications"]}</b></div>
            <table  >
              <tbody>
                <tr>
                  <td>
                    <PagingTable 
                      ref="table" 
                      SearchParams={[{ Parameter: "customerId", SearchValue: this.CustomerId }]} 
                      TableReference={this} 
                      DataBaseTable={"B2KundenEigen"} 
                      Selectable={false} 
                      Limit={this.state.Limit}
                      Start={this.state.Start}
                      End={this.state.End}
                      Count={this.state.Count} 
                      Columns={[Vas.Resources.Labels["Document"],Vas.Resources.Labels["ValidFrom"],Vas.Resources.Labels["ValidTo"]
                                ,Vas.Resources.Labels["IdentificationNumberShort"],Vas.Resources.Labels["Action"]]}
                      Keys={["Name","DateFrom","DateTo","IdentificationNumber"]} 
                      Data={this.state.Data} 
                      Download={true} 
                      DownloadOnClick={(event)=>{this.Download(event);}} 
                      Add={true} 
                      AddClick={()=>{this.Upload();}}
                      Border={false}
                      DownloadType={"Verification"}
                      AppURL={Vas.ApplicationUrl} 
                      SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
                      ApiURL={Vas.ApiUrl} 
                      ApiKey={Vas.ApiKey}
                      Token={localStorage.getItem('vas_token')}
                      TooltipSearchName={Vas.Resources.Tooltips["SearchName"]} 
                      TooltipCsvDownload={Vas.Resources.Tooltips["CsvDownload"]}
                      LabelPage={Vas.Resources.Labels["Page"]} 
                      LabelOf={Vas.Resources.Labels["Of"]} 
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      CWidth={[140,80,80,85,85]}
                      Modus={"Abellio"}
                      AddString={Vas.Resources.Labels["Add"]}
                      ShowIcons={this.IconConfig.ShowIcons}
                      UseBurgerMenu={false}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    {upload}  
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default CustomerVerificationData;
